"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _commonService = require("../../../services/common-service");

var _commonConstants = require("../../../utils/common-constants");

var _action = require("../../notification/action");

var _actions = require("./actions");

var _constants = require("./constants");

var _service = require("./service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(usersDataWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(usersDataWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(groupsDataWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(groupsDataWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(tagMembersDataWatcher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(tagMembersDataWorker),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(serviceIdentitiesDataWatcher),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(serviceIdentitiesDataWorker),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(tokensDataWatcher),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(tokensDataWorker),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(paginatedUsersDataWatcher),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(paginatedUsersDataWorker),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(paginatedUserTagsDataWatcher),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(paginatedUserTagsDataWorker);

function usersDataWatcher() {
  return regeneratorRuntime.wrap(function usersDataWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.UsersType.USERS_REQUEST, usersDataWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function usersDataWorker() {
  var response, _response$data, _response, reason;

  return regeneratorRuntime.wrap(function usersDataWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)((0, _actions.getUsersRequestLoading)());

        case 3:
          _context2.next = 5;
          return (0, _effects.call)(_service.fetchUsers);

        case 5:
          response = _context2.sent;
          _context2.next = 8;
          return (0, _effects.put)((0, _actions.getUsersRequestSuccess)(response));

        case 8:
          _context2.next = 18;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](0);
          _response = _context2.t0.response;
          reason = (_response === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context2.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context2.next = 18;
          return (0, _effects.put)((0, _actions.getUsersRequestFailure)(reason));

        case 18:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 10]]);
}

function groupsDataWatcher() {
  return regeneratorRuntime.wrap(function groupsDataWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.GroupsType.GROUPS_REQUEST, groupsDataWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function groupsDataWorker() {
  var response, _response2$data, _response2, reason;

  return regeneratorRuntime.wrap(function groupsDataWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.put)((0, _actions.getGroupsRequestLoading)());

        case 3:
          _context4.next = 5;
          return (0, _effects.call)(_service.fetchGroups);

        case 5:
          response = _context4.sent;
          _context4.next = 8;
          return (0, _effects.put)((0, _actions.getGroupsRequestSuccess)(response));

        case 8:
          _context4.next = 18;
          break;

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](0);
          _response2 = _context4.t0.response;
          reason = (_response2 === null || _response2 === void 0 ? void 0 : (_response2$data = _response2.data) === null || _response2$data === void 0 ? void 0 : _response2$data.message) || '';
          _context4.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context4.next = 18;
          return (0, _effects.put)((0, _actions.getGroupsRequestFailure)(reason));

        case 18:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 10]]);
}

function tagMembersDataWatcher() {
  return regeneratorRuntime.wrap(function tagMembersDataWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.TagMembersType.TAG_MEMBERS_REQUEST, tagMembersDataWorker);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function tagMembersDataWorker(_ref3) {
  var payload, response, _response3$data, _response3, reason;

  return regeneratorRuntime.wrap(function tagMembersDataWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref3.payload;
          _context6.prev = 1;
          _context6.next = 4;
          return (0, _effects.put)((0, _actions.getTagMembersRequestLoading)());

        case 4:
          _context6.next = 6;
          return (0, _effects.call)(_commonService.fetchData, payload);

        case 6:
          response = _context6.sent;
          _context6.next = 9;
          return (0, _effects.put)((0, _actions.getTagMembersRequestSuccess)(response));

        case 9:
          _context6.next = 19;
          break;

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](1);
          _response3 = _context6.t0.response;
          reason = (_response3 === null || _response3 === void 0 ? void 0 : (_response3$data = _response3.data) === null || _response3$data === void 0 ? void 0 : _response3$data.message) || '';
          _context6.next = 17;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 17:
          _context6.next = 19;
          return (0, _effects.put)((0, _actions.getTagMembersRequestFailure)(reason));

        case 19:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 11]]);
}

function serviceIdentitiesDataWatcher() {
  return regeneratorRuntime.wrap(function serviceIdentitiesDataWatcher$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_constants.ServiceIdentitiesType.SERVICE_IDENTITY_REQUEST, serviceIdentitiesDataWorker);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function serviceIdentitiesDataWorker() {
  var response, _response4$data, _response4, reason;

  return regeneratorRuntime.wrap(function serviceIdentitiesDataWorker$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.put)((0, _actions.getServiceIdentitiesRequestLoading)());

        case 3:
          _context8.next = 5;
          return (0, _effects.call)(_service.fetchServiceIdentities);

        case 5:
          response = _context8.sent;
          _context8.next = 8;
          return (0, _effects.put)((0, _actions.getServiceIdentitiesRequestSuccess)(response));

        case 8:
          _context8.next = 18;
          break;

        case 10:
          _context8.prev = 10;
          _context8.t0 = _context8["catch"](0);
          _response4 = _context8.t0.response;
          reason = (_response4 === null || _response4 === void 0 ? void 0 : (_response4$data = _response4.data) === null || _response4$data === void 0 ? void 0 : _response4$data.message) || '';
          _context8.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context8.next = 18;
          return (0, _effects.put)((0, _actions.getServiceIdentitiesRequestFailure)(reason));

        case 18:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[0, 10]]);
}

function tokensDataWatcher() {
  return regeneratorRuntime.wrap(function tokensDataWatcher$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_constants.TokensType.TOKENS_REQUEST, tokensDataWorker);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function tokensDataWorker() {
  var response, _response5$data, _response5, reason;

  return regeneratorRuntime.wrap(function tokensDataWorker$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.put)((0, _actions.getTokensRequestLoading)());

        case 3:
          _context10.next = 5;
          return (0, _effects.call)(_service.fetchTokens);

        case 5:
          response = _context10.sent;
          _context10.next = 8;
          return (0, _effects.put)((0, _actions.getTokensRequestSuccess)(response));

        case 8:
          _context10.next = 18;
          break;

        case 10:
          _context10.prev = 10;
          _context10.t0 = _context10["catch"](0);
          _response5 = _context10.t0.response;
          reason = (_response5 === null || _response5 === void 0 ? void 0 : (_response5$data = _response5.data) === null || _response5$data === void 0 ? void 0 : _response5$data.message) || '';
          _context10.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context10.next = 18;
          return (0, _effects.put)((0, _actions.getTokensRequestFailure)(reason));

        case 18:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10, null, [[0, 10]]);
}

function paginatedUsersDataWatcher() {
  return regeneratorRuntime.wrap(function paginatedUsersDataWatcher$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)(_constants.UserPaginatedType.USERS_REQUEST, paginatedUsersDataWorker);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function paginatedUsersDataWorker(_ref7) {
  var _ref7$payload, payload, _state$membersReducer, _state$membersReducer2, state, oldSearchTerm, apiParams, shouldAppend, policyListResponse;

  return regeneratorRuntime.wrap(function paginatedUsersDataWorker$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _ref7$payload = _ref7.payload, payload = _ref7$payload === void 0 ? {} : _ref7$payload;
          _context12.prev = 1;
          _context12.next = 4;
          return (0, _effects.select)();

        case 4:
          state = _context12.sent;
          oldSearchTerm = state === null || state === void 0 ? void 0 : (_state$membersReducer = state.membersReducer) === null || _state$membersReducer === void 0 ? void 0 : (_state$membersReducer2 = _state$membersReducer.paginatedUsers) === null || _state$membersReducer2 === void 0 ? void 0 : _state$membersReducer2.searchText;
          apiParams = {
            page: payload.page,
            size: payload.size
          };
          shouldAppend = payload.page !== 0;

          if (!payload.searchText && oldSearchTerm !== null && oldSearchTerm !== void 0 && oldSearchTerm.length && payload.page !== 0) {
            apiParams.searchText = oldSearchTerm;
          } else if (payload.searchText && !oldSearchTerm) {
            apiParams.searchText = payload.searchText;
            shouldAppend = false;
          } else if (payload.searchText) {
            apiParams.searchText = payload.searchText;
            shouldAppend = false;
          }

          _context12.next = 11;
          return (0, _effects.put)({
            type: _constants.UserPaginatedType.USERS_LOADING
          });

        case 11:
          _context12.next = 13;
          return (0, _effects.call)(_service.fetchPaginatedUsers, apiParams);

        case 13:
          policyListResponse = _context12.sent;
          _context12.next = 16;
          return (0, _effects.put)({
            type: shouldAppend ? _constants.UserPaginatedType.USERS_SUCCESS_LOAD_MORE : _constants.UserPaginatedType.USERS_SUCCESS,
            payload: _objectSpread(_objectSpread({}, policyListResponse), {}, {
              searchText: payload.searchText
            })
          });

        case 16:
          _context12.next = 22;
          break;

        case 18:
          _context12.prev = 18;
          _context12.t0 = _context12["catch"](1);
          _context12.next = 22;
          return (0, _effects.put)({
            type: _constants.UserPaginatedType.USERS_FAILURE,
            payload: _context12.t0
          });

        case 22:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12, null, [[1, 18]]);
}

function paginatedUserTagsDataWatcher() {
  return regeneratorRuntime.wrap(function paginatedUserTagsDataWatcher$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)(_constants.UserTagsPaginatedType.USERS_TAGS_REQUEST, paginatedUserTagsDataWorker);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function paginatedUserTagsDataWorker(_ref8) {
  var _ref8$payload, payload, _state$membersReducer3, _state$membersReducer4, state, oldSearchTerm, apiParams, shouldAppend, policyListResponse;

  return regeneratorRuntime.wrap(function paginatedUserTagsDataWorker$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _ref8$payload = _ref8.payload, payload = _ref8$payload === void 0 ? {} : _ref8$payload;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.select)();

        case 4:
          state = _context14.sent;
          oldSearchTerm = state === null || state === void 0 ? void 0 : (_state$membersReducer3 = state.membersReducer) === null || _state$membersReducer3 === void 0 ? void 0 : (_state$membersReducer4 = _state$membersReducer3.paginatedUsers) === null || _state$membersReducer4 === void 0 ? void 0 : _state$membersReducer4.searchText;
          apiParams = {
            page: payload.page,
            size: payload.size
          };
          shouldAppend = payload.page !== 0;

          if (!payload.searchText && oldSearchTerm !== null && oldSearchTerm !== void 0 && oldSearchTerm.length && payload.page !== 0) {
            apiParams.searchText = oldSearchTerm;
          } else if (payload.searchText && !oldSearchTerm) {
            apiParams.searchText = payload.searchText;
            shouldAppend = false;
          } else if (payload.searchText) {
            apiParams.searchText = payload.searchText;
            shouldAppend = false;
          }

          _context14.next = 11;
          return (0, _effects.put)({
            type: _constants.UserTagsPaginatedType.USERS_TAGS_LOADING
          });

        case 11:
          _context14.next = 13;
          return (0, _effects.call)(_service.fetchPaginatedTags, apiParams);

        case 13:
          policyListResponse = _context14.sent;
          _context14.next = 16;
          return (0, _effects.put)({
            type: shouldAppend ? _constants.UserTagsPaginatedType.USERS_TAGS_SUCCESS_LOAD_MORE : _constants.UserTagsPaginatedType.USERS_TAGS_SUCCESS,
            payload: _objectSpread(_objectSpread({}, policyListResponse), {}, {
              searchText: payload.searchText
            })
          });

        case 16:
          _context14.next = 22;
          break;

        case 18:
          _context14.prev = 18;
          _context14.t0 = _context14["catch"](1);
          _context14.next = 22;
          return (0, _effects.put)({
            type: _constants.UserTagsPaginatedType.USERS_TAGS_FAILURE,
            payload: _context14.t0
          });

        case 22:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14, null, [[1, 18]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(usersDataWatcher), (0, _effects.fork)(groupsDataWatcher), (0, _effects.fork)(tokensDataWatcher), (0, _effects.fork)(serviceIdentitiesDataWatcher), (0, _effects.fork)(tagMembersDataWatcher), (0, _effects.fork)(paginatedUsersDataWatcher), (0, _effects.fork)(paginatedUserTagsDataWatcher)]);

exports.default = _default;